<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.key"
          style="width: 20%"
          placeholder="搜索评价内容/评价人"
          clearable
          @clear="onLoad()"
        ></el-input>
        <el-select
          v-model="state.params.spId"
          placeholder="商品ID"
          clearable
          style="width: 12%; margin-left: 10px"
          @change="onLoad()"
        >
          <el-input
            v-model="state.params.spId"
            placeholder="输入商品ID"
          ></el-input>
        </el-select>
        <el-select
          v-model="state.params.xj"
          placeholder="评分"
          clearable
          style="width: 10%; margin-left: 10px"
          @change="onLoad()"
        >
          <el-option label="5星" :value="5"></el-option>
          <el-option label="4星" :value="4"></el-option>
          <el-option label="3星" :value="3"></el-option>
          <el-option label="2星" :value="2"></el-option>
          <el-option label="1星" :value="1"></el-option>
        </el-select>
        <el-select
          v-model="state.params.shZt"
          placeholder="审核状态"
          clearable
          style="width: 12%; margin-left: 10px"
          @change="onLoad()"
        >
          <el-option label="待审核" :value="0"></el-option>
          <el-option label="已通过" :value="1"></el-option>
          <el-option label="已拒绝" :value="2"></el-option>
        </el-select>
        <el-dropdown
          split-button
          @click="onLoad()"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.order,
          order: state.params.asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.pageIndex - 1) * state.params.pageSize + index + 1
          "
          align="center"
        />
        <el-table-column prop="SpId" label="商品ID" align="center" width="80" />
        <el-table-column prop="SpMc" label="商品名称" min-width="150" />
        <el-table-column label="评分" sortable="Xj" align="center" width="90">
          <template #default="{ row }">
            <el-rate v-model="row.Xj" disabled size="small" />
          </template>
        </el-table-column>
        <el-table-column prop="CjrXm" label="评价人" width="100" />
        <el-table-column label="评价内容" min-width="200" show-overflow-tooltip>
          <template #default="{ row }">
            {{ row.PjNr }}
          </template>
        </el-table-column>
        <el-table-column label="评价标签" width="160">
          <template #default="{ row }">
            <el-tag
              v-for="tag in (row.PjBq || '').split(',').filter(Boolean)"
              :key="tag"
              size="small"
              type="info"
              style="margin: 2px"
              >{{ tag }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="审核状态" sortable="ShZt" align="center" width="90">
          <template #default="{ row }">
            <el-tag v-if="row.ShZt == 1" type="success" size="small">已通过</el-tag>
            <el-tag v-else-if="row.ShZt == 0" type="warning" size="small">待审核</el-tag>
            <el-tag v-else type="danger" size="small">已拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="启停" align="center" width="70">
          <template #default="{ row }">
            <el-tag v-if="row.IsQy" type="success" size="small">启用</el-tag>
            <el-tag v-else type="info" size="small">停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="IsNm" label="匿名" align="center" width="60">
          <template #default="{ row }">
            <span v-if="row.IsNm" style="color: #999">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="HfNr"
          label="商家回复"
          width="120"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <span v-if="row.HfNr" style="color: #409eff">已回复</span>
            <span v-else style="color: #999">未回复</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="创建时间"
          width="160"
          :formatter="(row) => formatTime(row.Cjsj)"
        />
        <el-table-column
          label="操作"
          width="300"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              v-if="row.ShZt == 0"
              type="success"
              :icon="Select"
              link
              @click="onSh(row.Id, 1)"
            >
              通过
            </el-button>
            <el-button
              v-if="row.ShZt == 0"
              type="danger"
              :icon="CloseBold"
              link
              @click="onSh(row.Id, 2)"
            >
              拒绝
            </el-button>
            <el-button
              type="warning"
              :icon="row.IsQy ? VideoPause : VideoPlay"
              link
              @click="onQy(row.Id)"
            >
              {{ row.IsQy ? '停用' : '启用' }}
            </el-button>
            <el-button
              type="primary"
              :icon="ChatDotRound"
              link
              @click="onOpenReply(row)"
            >
              回复
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row.Id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.pageIndex"
        @onLoad="
          (pageIndex) => {
            state.params.pageIndex = pageIndex;
            onLoad();
          }
        "
      >
      </c_page>
    </ul>

    <!-- 回复弹窗 -->
    <el-dialog
      v-model="state.replyVisible"
      title="商家回复"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-input
        v-model="state.replyContent"
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 8 }"
        placeholder="请输入回复内容"
        maxlength="1000"
        show-word-limit
      />
      <template #footer>
        <el-button @click="state.replyVisible = false">取消</el-button>
        <el-button type="primary" @click="onReply()" :loading="state.replying"
          >确认回复</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive } from "vue";
import {
  shangpinpingjia_getlist,
  shangpinpingjia_sh,
  shangpinpingjia_qy,
  shangpinpingjia_hf,
  shangpinpingjia_delete,
} from "@/http/api";

export default {
  setup() {
    const { proxy } = getCurrentInstance();
    const state = reactive({
      params: {
        pageSize: 20,
        pageIndex: 1,
        order: "Id",
        asc: false,
      },
      replyVisible: false,
      replyContent: "",
      replyId: null,
      replying: false,
    });

    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      shangpinpingjia_getlist(state.params).then((res) => {
        if (res.status == 200) {
          const { total, list } = res.data;
          state.tableData = list;
          state.totalCount = total;
        }
      });
    };

    //排序
    const onSortChange = (column) => {
      state.params.order = column.prop;
      state.params.asc = column.order === "ascending";
      onLoad();
    };

    //重置
    const onReset = () => {
      state.params = { pageSize: 20, pageIndex: 1, order: "Id", asc: false };
      onLoad();
    };

    //审核
    const onSh = (id, shZt) => {
      const tip = shZt == 1 ? "确定要通过此评价吗？" : "确定要拒绝此评价吗？";
      const type = shZt == 1 ? "success" : "warning";
      proxy
        .$confirm(tip, "审核确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: type,
        })
        .then(() => {
          shangpinpingjia_sh(id, shZt).then((res) => {
            if (res.status == 200) {
              proxy.$message.success(res.data);
              onLoad();
            }
          });
        });
    };

    //启停
    const onQy = (id) => {
      shangpinpingjia_qy(id).then((res) => {
        if (res.status == 200) {
          proxy.$message.success(res.data);
          onLoad();
        }
      });
    };

    //打开回复弹窗
    const onOpenReply = (row) => {
      state.replyId = row.Id;
      state.replyContent = row.HfNr || "";
      state.replyVisible = true;
    };

    //提交回复
    const onReply = () => {
      if (!state.replyContent?.trim()) return;
      state.replying = true;
      shangpinpingjia_hf(state.replyId, state.replyContent.trim())
        .then((res) => {
          if (res.status == 200) {
            proxy.$message.success(res.data);
            state.replyVisible = false;
            onLoad();
          }
        })
        .finally(() => {
          state.replying = false;
        });
    };

    //删除
    const onDelete = (id) => {
      proxy.$confirm_func(shangpinpingjia_delete, id, onLoad);
    };

    //格式化时间
    const formatTime = (time) => {
      if (!time) return "";
      return new Date(time).toLocaleString("zh-CN");
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onSh,
      onQy,
      onOpenReply,
      onReply,
      onDelete,
      formatTime,
    };
  },
};
</script>
<style scoped></style>
